import { getCircleRadius } from "src/components/canvas/helper";

const actions = {
  CANVAS_CURSOR: "CANVAS_CURSOR",
  CANVAS_PROPERTIES_SET_VALUE: "CANVAS_PROPERTIES_SET_VALUE",
  CANVAS_SET_VALUE: "CANVAS_SET_VALUE",
  POLYGONS_REMOVE_VALUE: "POLYGONS_REMOVE_VALUE",
  POLYGONS_SET_BACKGROUND_IMAGE: "POLYGONS_SET_BACKGROUND_IMAGE",
  POLYGONS_SET_VALUE: "POLYGONS_SET_VALUE",
  RE_SET_VALUE: "RE_SET_VALUE",

  removePolygonsValue: () => ({
    type: actions.POLYGONS_REMOVE_VALUE,
  }),
  resetValue: () => ({
    type: actions.RE_SET_VALUE,
  }),
  setCanvasPropertiesValue: (zoomLevel) => {
    return {
      strokeWidth: getCircleRadius(zoomLevel),
      type: actions.CANVAS_PROPERTIES_SET_VALUE,
      zoomLevel,
    };
  },
  setCanvasValue: (canvas) => ({
    type: actions.CANVAS_SET_VALUE,
    value: canvas,
  }),
  setPolygonsBackgroundImage: (image) => ({
    type: actions.POLYGONS_SET_BACKGROUND_IMAGE,
    value: image,
  }),
  setPolygonsValue: (polygons) => ({
    type: actions.POLYGONS_SET_VALUE,
    value: polygons,
  }),
  toggleCanvasCursor: () => ({
    type: actions.CANVAS_CURSOR,
  }),
};
export default actions;
